/* The audit list: the filter toolbar, the problem line, and the table's scroll box. */
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

.field input,
.field select {
  block-size: var(--control-height);
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-regular);
}

.field input:focus-visible,
.field select:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.actions {
  display: flex;
  gap: var(--space-2);
}

.hint {
  flex-basis: 100%;
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.problem {
  margin: var(--space-2) 0 0;
  color: var(--danger-text);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.scroll {
  overflow-x: auto;
}

.trashed {
  color: var(--text-subtle);
}
